import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourDoneKey, TourId } from 'webapp/enums/tour';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';
import { HiddenTourStep } from 'webapp/models-custom/tour/designer/option-hidden';

export default class DesignerSharableLinkTour extends TourBase {
	static keyForPersistantDone = TourDoneKey.DESIGNER__SHARABLE_LINK;

	get id(): string {
		return TourId.DESIGNER__SHARABLE_LINK;
	}

	override get keyForPersistantDone(): string {
		return DesignerSharableLinkTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.UP,
				allowStacked: true,
				attachTo: () => {
					return $('#boardSettings .link');
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override end(): void {
		super.end();
		this.flowTourDesignerService.resetHiddenTourExplicitlyClosedStatus(
			HiddenTourStep.BOARD_OPTIONS_HIDDEN,
		);
	}
}
